<script setup>
import {defineProps} from "vue";

const prop = defineProps({
  sms: {
    type: Boolean,
    default: () => false
  }
})
const modifyMobile = () => {
  window.location.href = `http://ffp.sichuanair.com/H5web/Certification/MobileEdit?version=&clientKey=&channelType=WEB&signtrue=68b7af29a4133f92ea7dcbfc4d7c6455&return_url=${window.location.href}`
}
const register = () => {
  window.location.href = 'https://pay.jifen360.com/third/tacx/register.html'
}

const forgotPassword = () => {
  window.location.href = `https://payment.jifen360.com/line/forget/index/scan?callBack=${window.location.href}`
}
</script>

<template>
  <div class="forgot">
    <el-button link type="primary" v-if="prop.sms" @click="modifyMobile">修改手机号</el-button>
    <el-button link type="primary" v-else @click="forgotPassword">忘记密码？</el-button>
    <el-button link type="primary" @click="register">没有账号？去注册</el-button>
  </div>
</template>

<style scoped lang="less">
.forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
